import ProductPromotionalPrice from './ProductPromotionalPrice';

export default ProductPromotionalPrice;
